import { getBackOfficeAPIPath } from '@treasury/core/http';

angular.module('backOffice').factory('jhaSupportService', jhaSupportService);

jhaSupportService.$inject = ['$resource', '$window'];

function jhaSupportService($resource, $window) {
    const resourceUrlBase = `${getBackOfficeAPIPath()}jhasupport/`;

    const JhaSupport = $resource(
        resourceUrlBase,
        {},
        {
            getInstitutions: {
                method: 'GET',
                isArray: true,
                url: `${resourceUrlBase}institutions`,
            },
            impersonateInstitution: {
                method: 'POST',
                url: `${resourceUrlBase}impersonateInstitution/:newInstitutionId`,
                // $resource interprets a string response as an array of characters,
                // wrapping it in an object to avoid that.
                transformResponse(data) {
                    return { fiId: JSON.parse(data) };
                },
            },
        }
    );

    const service = {
        getInstitutions,
        setUserFiId,
        getUserFiId,
        impersonateInstitution,
    };

    return service;

    function getInstitutions() {
        return JhaSupport.getInstitutions().$promise;
    }

    function setUserFiId(userFiId) {
        const normalizedUserFiId = normalizeUserFiId(userFiId);
        return $window.sessionStorage.setItem('userFiId', normalizedUserFiId);
    }

    function getUserFiId() {
        const storedUserFiId = $window.sessionStorage.getItem('userFiId');
        const normalizedUserFiId = normalizeUserFiId(storedUserFiId); // for legacy reads
        if (!normalizedUserFiId && storedUserFiId) {
            $window.sessionStorage.removeItem('userFiId');
        }
        return normalizedUserFiId;
    }

    function impersonateInstitution(newInstitutionId) {
        return JhaSupport.impersonateInstitution({ newInstitutionId }, null).$promise.then(
            response => {
                setUserFiId(response.fiId);
            }
        );
    }

    function normalizeUserFiId(userFiId) {
        if (!userFiId) {
            return '';
        }
        if (typeof userFiId === 'object') {
            return userFiId.fiid || userFiId.fiId || '';
        }
        const normalizedUserFiId = String(userFiId).trim();
        if (!normalizedUserFiId || normalizedUserFiId === '[object Object]') {
            return '';
        }
        if (normalizedUserFiId.charAt(0) === '{') {
            try {
                return normalizeUserFiId(JSON.parse(normalizedUserFiId));
            } catch (error) {
                return normalizedUserFiId;
            }
        }
        return normalizedUserFiId;
    }
}
